
// images
import logoUnicamp from '@/assets/logo_unicamp.gif';
import logoFeagri from '@/assets/lg_feagricompleto.gif';
import dacImagem from '@/assets/dac-imagem.png';
import { AlertMessage } from '@/components/shared/AlertMessage';

import { useNavigate } from 'react-router-dom';
import { Loading } from '@/components/shared/Loading';
import { IDetalhesEmentaComponentProps } from '@/@types/Graduacao/DisciplinasEmenta'

import { Button } from '@/components/ui/button';
import { useEffect } from 'react';

/**
 * Componente responsável por exibir os detalhes da ementa de uma disciplina.
 * @param isLoading Indica se os dados estão sendo carregados.
 * @param data Dados detalhados da disciplina.
 * @returns Componente de detalhes da disciplina.
 */

const DetalhesEmentaComponent = ({ isLoading, data }: IDetalhesEmentaComponentProps) => {

    const navigate = useNavigate();

    useEffect(() => {
        // rolagem para o início da tela
        window.scrollTo({
            top: 0,
            behavior: "smooth" // Opção para uma animação de rolagem suave
        });
    },[]);

    return (
        <>
            {
                isLoading ? (
                    <Loading color='primary' />
                ) : (
                    <>
                        {data && Object.keys(data).length > 0 ? (
                            <>
                                <div>
                                    <div className="card-header d-flex .flex-row justify-content-between">
                                        <div className="lg:flex mr-2 space-x-[10px]">
                                            <img className='h-[70px]' src={logoUnicamp} alt="Unicamp" /> &nbsp;
                                            <img className='h-[60px]' src={logoFeagri} alt="FEAGRI" />
                                        </div>
                                        <div className="col-md-8 text-center mr-5 ml-5">
                                            <h5>UNIVERSIDADE ESTADUAL DE CAMPINAS</h5>
                                            <h5>DIRETORIA ACADÊMICA</h5>
                                            <h5><strong>PROGRAMAS E BIBLIOGRAFIAS</strong></h5>
                                        </div>
                                        <div className="col-md-2 text-right">
                                            <img src={dacImagem} width="125" height="125" alt="DAC" />
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive">

                                        <table className="table table-sm">
                                            <thead>
                                            </thead>
                                            <tbody>
                                                <tr className="table-default d-flex justify-content-end">
                                                    <td className="bg-grey font-weight-bold" scope="col"><small> ANO CATÁLOGO</small></td>
                                                    <td className="font-weight-bold" scope="col"><small> {data?.ANO_CATAL}</small></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table className="table table-sm">
                                            <thead>
                                                <tr className="table-default">
                                                    <th className="bg-grey font-weight-bold" scope="col"><small> DISCIPLINA</small></th>
                                                    <th className="bg-grey font-weight-bold" scope="col"><small> NOME</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><small> {data?.COD_DISCI}</small></td>
                                                    <td><small> {data?.NOME_DISCI}</small></td>
                                                </tr>
                                                <tr>
                                                    <td><small> &nbsp; </small></td>
                                                    <td><small> {data?.NOME_DISCI_INGL}</small></td>
                                                </tr>
                                                <tr>
                                                    {data?.NOME_DOCENTE && <td colSpan={2}>Docente responsável:<small> {data?.NOME_DOCENTE}</small></td>}
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="table table-sm">
                                            <thead>
                                                <tr className="table-default">
                                                    <th className="bg-grey font-weight-bold" scope="col"><small> Pré-requisitos</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="cad-text preline" dangerouslySetInnerHTML={{ __html: data?.DESC_ATIV_CAD || "" }}></div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table className="table table-sm">
                                            <thead>
                                                <tr className="table-default">
                                                    <th className="bg-grey font-weight-bold" scope="col" colSpan={7}><small> Horas semanais</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="bg-grey font-weight-bold"><small> Teóricas </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Práticas </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Laboratório</small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Orientação</small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Distância</small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Estudo em Casa</small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Sala de Aula</small></td>
                                                </tr>
                                                <tr>
                                                    <td><small> {data?.NUM_TOT_TEORI}</small></td>
                                                    <td><small> {data?.NUM_TOT_PRAT}</small></td>
                                                    <td><small> {data?.NUM_TOT_LAB}</small></td>
                                                    <td><small> {data?.NUM_TOT_ATIV_ORI}</small></td>

                                                    <td><small> 0</small></td>

                                                    <td><small> {data?.NUM_TOT_ESTU}</small></td>
                                                    <td><small>{data?.NUM_TOT_SALA}</small></td>
                                                </tr>
                                                <tr>
                                                    <td className="bg-grey font-weight-bold"><small> Nº semanas </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Carga horária total </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> &nbsp; </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Créditos </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Exame </small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Frequência</small></td>
                                                    <td className="bg-grey font-weight-bold"><small> Aprovação</small></td>
                                                </tr>
                                                <tr>
                                                    <td><small> {data?.NUM_SEM}</small></td>
                                                    <td><small>{data?.CARGA_HORARIA}</small></td>
                                                    <td><small> &nbsp;</small></td>
                                                    <td><small> {data?.NUM_CRED_DISCI}</small></td>
                                                    <td><small>{data?.EXAME}{data?.EXAME == 'S' ? 'im' : ''}</small></td>
                                                    <td><small> {data?.PERC_FREQ}%</small></td>
                                                    <td><small> {data?.TIPO_APROV}{data?.TIPO_APROV == 'N' ? 'ota' : ''}</small></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="table table-sm">
                                            <thead>
                                                <tr className="table-default">
                                                    <th className="bg-grey font-weight-bold" scope="col"><small> Ementa</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {/* <div className="cad-text preline" [innerHTML]="ementa"></div> */}
                                                        <div className="cad-text preline" dangerouslySetInnerHTML={{ __html: data?.DESC_EMEN }}></div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {/* <div className="cad-text preline" [innerHTML]="descEmentaIngl"></div> */}
                                                        <div className="cad-text preline" dangerouslySetInnerHTML={{ __html: data?.DESC_EMEN_INGLES }}></div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >

                                        <table className="table table-sm">
                                            <thead>
                                                <tr className="table-default">
                                                    <th className="bg-grey font-weight-bold" scope="col"><small> Programa</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {/* <div className="cad-text preline" [innerHTML]="programa"></div> */}
                                                        <div className="cad-text preline" dangerouslySetInnerHTML={{ __html: data?.DESC_PROG }}></div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >
                                        <table className="table table-sm">
                                            <thead>
                                                <tr className="table-default">
                                                    <th className="bg-grey font-weight-bold" scope="col"><small> Bibliografia</small></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {/* <div className="cad-text preline" [innerHTML]="bibliografia"></div> */}
                                                        <div className="cad-text preline" dangerouslySetInnerHTML={{ __html: data?.DESC_BIBL }}></div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >


                                    </div >
                                </div >
                            </>
                        ) : (
                            <>
                                <AlertMessage message='Algo deu errado. Tente novamente mais tarde' />
                                <Button className='block m-auto text-lg' onClick={() => navigate(-1)} variant='linkSecondary'>Voltar</Button>
                            </>
                        )}

                    </>
                )
            }

        </>
    );

}

export { DetalhesEmentaComponent };